import { message } from 'components';
import { useUpdateSystemConfigAIAgentMutation } from 'services';
import { SystemConfigAIAgentDto, UpdateSystemConfigAIAgentDto } from 'types/dto/system-configs';
export function useUpdateSystemConfigAIAgent() {
  const [onUpdate, { isLoading }] = useUpdateSystemConfigAIAgentMutation();
  const onUpdateConfig = (
    values: UpdateSystemConfigAIAgentDto,
    onChangeSuccess?: (rs: SystemConfigAIAgentDto) => void
  ) => {
    onUpdate({
      ...values
    })
      .unwrap()
      .then((rs) => {
        message.systemSuccess(rs.message);
        onChangeSuccess?.(rs.data);
      });
  };

  return {
    onUpdateConfig,
    isLoading
  };
}
